// Customer-facing feature flags.
//
// VULNERABILITY_ENABLED — when false, the vulnerability ("Understanding Your
// Needs") questionnaire is hidden from the entire UW customer journey:
//   • UWOnboardingFlow      — the Privacy/Health/Life-Events/Resilience/Capability steps
//   • UWKycReviewPage        — the "Understanding your needs details" review card
//   • profilePage            — the "Other circumstances" card + edit dialog
// No data is deleted and the agent/creditor side is unaffected; flip this back
// to true to fully restore the feature.
export const VULNERABILITY_ENABLED = false;
